import { useMemo } from 'react';
import { pick } from 'lodash';

const fallbackValues = {
	password: '',
	passwordConfirm: '',
};

const useConfirmPasswordResetFormInitialValues = data =>
	useMemo(
		() => ({
			...fallbackValues,
			...pick(data, ['password', 'passwordConfirm']),
		}),
		[data],
	);

export default useConfirmPasswordResetFormInitialValues;
